module.exports = __webpack_public_path__ + "img/image3.da8f58fc.png";